import {observer} from "mobx-react-lite";
import React, {useEffect, useRef, useState} from 'react';
import {toast} from "react-toastify";
import api from "../../../api/api";
import {useStore} from "../../../hooks/useStore";
import InputBox from "./input_box";
import classNames from "classnames";
import s from './styles.module.css';
import {Tooltip} from "@mui/material";

const FigureBox2 = observer(({
                                 id,
                                 socketData,
                                 judgleStatus,
                                 setOpenDialogCustom,
                                 setCoachTypeId,
                                 setCoachTypeNumber
                             }) => {

    const findScroll = () => {
        let scrolls = [];
        let i = 0;
        figureData?.figure?.forEach(el => {
            el.users.forEach((user) => {
                if (user.is_processing_discipline_figure_id !== null && user.is_processing_discipline_figure_id !== undefined) {
                    let index = user.scores[0].number_brigade - 1;
                    let scrollTop = (user.sort - 1) * 103;
                    scrolls[i] = {index, scrollTop};
                    i++;
                }
            })
        })
        return scrolls;
    }

    const {figure} = useStore()
    const [figureData, setFigureData] = useState(figure)
    const [updateInput, setUpdateInput] = useState(false)
    const blockRefs = useRef([]);
    const [blockScrollPositions, setBlockScrollPositions] = useState(findScroll);
    const [user1, setUser1] = useState(0);
    const [user2, setUser2] = useState(0);
    const [user3, setUser3] = useState(0);
    const [user4, setUser4] = useState(0);

    useEffect(() => {
        if (blockScrollPositions) {
            blockScrollPositions.forEach(({index, scrollTop}) => {
                if (blockRefs.current[index]) {
                    blockRefs.current[index].scrollTop = scrollTop;
                }
            });
        }
    }, [figureData, id]);

    const handleScroll = (index, scrollTop) => {
        setBlockScrollPositions(prevBlockScrollPositions => {
            const updatedBlockScrollPositions = [...prevBlockScrollPositions];
            updatedBlockScrollPositions[index] = {index, scrollTop};
            return updatedBlockScrollPositions;
        });
    };


    useEffect(() => {
        if (socketData?.method === "update_user_figure") {
            const getUpdateScor = async () => {
                try {
                    const res = await api().get(`/figure/figure_brigade/user_scores/${socketData?.application_figure_id}/${socketData?.figure_id}`)
                    setUpdateInput(!updateInput)

                    handleScroll(res?.data?.scores[0]?.number_brigade - 1, (res.data.sort - 1) * 103);
                    let numberBrigade = res?.data?.scores[0]?.number_brigade;
                    let userId = res?.data?.user_id;

                    switch (numberBrigade) {
                        case 1: {
                            setUser1(userId);
                            break;
                        }
                        case 2: {
                            setUser2(userId);
                            break;
                        }
                        case 3: {
                            setUser3(userId);
                            break;
                        }
                        case 4: {
                            setUser4(userId);
                            break;
                        }
                    }

                    setFigureData({
                        ...figureData,
                        figure: figureData?.figure?.map((el) => el?.figure_id === socketData?.figure_id ? ({
                                ...el,
                                users: el?.users?.map((user) => user?.user_id === res?.data?.user_id ? ({
                                    ...user,
                                    scores: res?.data?.scores,
                                    result_figure: res?.data?.result_figure,
                                    penalty: res?.data?.penalty,
                                }) : user)
                            }) : el
                        )
                    })

                } catch (e) {
                    console.log(e)
                    toast.error('Ошибка')
                }

            }
            getUpdateScor()

        }
    }, [socketData, figure])

    // console.log(figureData)
    return (
        <div className={s.content}>
            <div id={"figure_content"} className={s.figure_content}>
                {figureData?.figure?.map((fig, ind_box) => {
                    const sort_data = fig.users?.slice()?.sort((a, b) => a.sort - b.sort)
                    // console.log(JSON.parse(JSON.stringify(fig.users?.find(f => f.user_id == 46))))
                    return <div className={s.figure_box} key={fig?.figure_id}
                                ref={el => blockRefs.current[ind_box] = el}
                                onScroll={e => handleScroll(ind_box, e.target.scrollTop)}>
                        <div className={s.figure_box_header}>
                            <p className={s.figure_box_header_title}>{fig.figure_name}</p>
                            <p
                                className={classNames(
                                    s.figure_box_header_title,
                                    judgleStatus.coach_type_5?.find((f) => f.coach_type_number === fig.brigade_number)?.status === 'disconnect' && s.disconnect,
                                    judgleStatus.coach_type_5?.find((f) => f.coach_type_number === fig.brigade_number)?.status === 'connect' && s.connect,
                                )}
                                onDoubleClick={() => {
                                    setOpenDialogCustom(true)
                                    setCoachTypeId(5)
                                    setCoachTypeNumber(fig.brigade_number)
                                }}
                            >
                                {fig.brigade_name}
                            </p>
                            <p className={s.figure_box_header_title}>{fig.figure_start}</p>
                        </div>

                        <div className={s.figure_box_jud}>
                            <div></div>
                            <div>Jd 1</div>
                            <div>Jd 2</div>
                            <div>Jd 3</div>
                            <div>Jd 4</div>
                            <div>Jd 5</div>
                            <div>Jd 6</div>
                            <div>Jd 7</div>
                            <div style={{minWidth: '82px'}}>Total</div>
                            <div style={{minWidth: '62px'}}>Penalty</div>
                        </div>

                        <div className={s.figure_box_content}>
                            {sort_data?.map((user, ind) => {
                                const sort_data_user = user?.scores?.slice()?.sort((a, b) => a?.number_coach - b?.number_coach)
                                const filtered_value_without = sort_data_user.filter((f) => f.value !== null)
                                const sum = filtered_value_without.reduce((acc, inc) => acc = acc + +inc.value, 0)

                                const littleArray = Array.from({length: 7 - sort_data_user.length}, (a, b) => a++)

                                return <div className={s.figure_box_content_item} key={`user-${user.user_id}`}>
                                    <div className={s.figure_box_content_item_top}>
                                        <Tooltip
                                            title={user?.is_not_started === 1 ? 'DNS' : user?.is_disqulified === 1 ? 'DSQ' : ''}
                                            placement="right"
                                            sx={{
                                                tooltip: {
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    fontSize: '14px',
                                                    padding: '1px 1px',
                                                    borderRadius: '4px',
                                                },
                                            }}
                                        >
                                            <div className={s.figure_box_content_item_number} style={{
                                                background: ((ind_box === 0 && user.user_id === user1) ||
                                                    (ind_box === 1 && user.user_id === user2) ||
                                                    (ind_box === 2 && user.user_id === user3) ||
                                                    (ind_box === 3 && user.user_id === user4)) ||
                                                (user.is_processing_discipline_figure_id !== null) ? 'rgb(134, 183, 96)' : user?.is_not_started === 1 || user?.is_disqulified === 1
                                                    ? 'rgba(255,0,0,.3)' : '#ffffff'
                                                // background: user.is_processing_discipline_figure_id !== null ? 'rgb(134, 183, 96)' : '#ffffff'
                                            }}>
                                                <p style={{
                                                    color: ((ind_box === 0 && user.user_id === user1) ||
                                                        (ind_box === 1 && user.user_id === user2) ||
                                                        (ind_box === 2 && user.user_id === user3) ||
                                                        (ind_box === 3 && user.user_id === user4)) ||
                                                    (user.is_processing_discipline_figure_id !== null) ? '#ffffff' : '#000000'
                                                }}>{user?.draw}</p>
                                            </div>
                                        </Tooltip>
                                        <div className={s.figure_box_content_item_name}>
                                            <p>{user?.user_name}</p>
                                        </div>
                                        <div className={s.figure_box_content_item_city}>
                                            <p>{user?.user_command || 'Город'}</p>
                                        </div>
                                    </div>

                                    <div className={s.figure_box_content_item_sub}>
                                        <div style={{minWidth: '50px'}}></div>
                                        {sort_data_user.map((score, ind) =>
                                            <InputBox index_box={ind_box}
                                                      is_read={user?.is_disqulified === 1 || user?.is_not_started === 1}
                                                      updateInput={updateInput}
                                                      score={score}
                                                      user_id={user.user_id}
                                                      id={score.score_figure_id}
                                                      value={score.value}
                                                      key={`score-${score?.number_coach}`}/>)}
                                        {littleArray.map((el) => <div style={{minWidth: '50px'}}/>)}
                                        <div style={{minWidth: '82px'}}
                                             className={s.score_full}>
                                            {user?.result_figure != null && !isNaN(+user.result_figure)
                                                ? Number(user.result_figure).toFixed(4)
                                                : ""}
                                        </div>
                                        <InputBox index_box={ind_box}
                                                  updateInput={updateInput}
                                                  id={user.user_id}
                                                  value={user.penalty}
                                                  penalty={true}/>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                })}
            </div>
        </div>
    );
});

export default FigureBox2;
